<template>
  <div class="spinner">
    <img :src="imageFilename">
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Spinner',
  props: {
    color: String
  },
  data: () => ({
    availableColors: ['white', 'black', 'teal', 'gold', 'violet', 'pastel-purple'],
    defaultColor: 'white'
  }),
  computed: {
    imageFilename: function() {
      const colorToDisplay = this.color && this.availableColors.includes(this.color) ? this.color : this.defaultColor;
      return require(`@/assets/spinners/${ colorToDisplay }.svg`);
    }
  }
})
</script>

<style scoped lang="scss">
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 100%;
  width: 1.2em;
  height: 1.2em;
  margin: 0 auto;
}

.spinner > img {
  max-width: 100%;
  max-height: 100%;
}
</style>
